export type Neighbors<T> = {
  previous?: T;
  next?: T;
  isResolved: boolean;
};

type ToNeighborsParams<T> = {
  items: T[];
  isCurrent(item: T): boolean;
  isNavigable?(item: T): boolean;
};

export default function toNeighbors<T>({
  items,
  isCurrent,
  isNavigable = () => true,
}: ToNeighborsParams<T>): Neighbors<T> {
  const index = items.findIndex(isCurrent);

  if (index < 0) return { isResolved: false };

  if (!isNavigable(items[index])) return { isResolved: true };

  const next = items.at(index + 1);

  return {
    previous: index > 0 ? items.at(index - 1) : undefined,
    next: next !== undefined && isNavigable(next) ? next : undefined,
    isResolved: index < items.length - 1,
  };
}
